import React, {useEffect, useRef, useState} from 'react';
import {Typography} from '@mui/material';
import AurSvgIcon from '../common/aur-svg-icon/AurSvgIcon';
import {t} from 'i18next';

interface AurEcaBadgesProps {
  admin: boolean;
  docSummary: boolean;
  smallPillText?: string;
  largePillText?: string;
}

const AurEcaBadges: React.FC<AurEcaBadgesProps> = (
  props: AurEcaBadgesProps
) => {
  const {admin, docSummary, smallPillText, largePillText} = props;
  const [isNarrow, setIsNarrow] = useState(false);

  const stringPath = 'eca.badges.'; // used for dynamically locate localization strings

  const textContainerRef = useRef<HTMLDivElement | null>(null);
  const pillContainerRef = useRef<HTMLDivElement | null>(null);

  const checkWidth = () => {
    if (textContainerRef.current && pillContainerRef.current) {
      setIsNarrow(
        textContainerRef.current.offsetWidth +
          pillContainerRef.current.offsetWidth >=
          475
      );
    }
  };

  useEffect(() => {
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  return (
    <div
      className={`aur-eca-badge-large-pill-container ${isNarrow ? 'narrow' : ''}`}
      aria-label={`${t(stringPath + 'earlyCaseAssessment')} ${admin ? t(stringPath + 'admin') : t(stringPath + 'nonAdmin')}`}
    >
      <div
        className="aur-eca-badge-small-pill-container"
        ref={pillContainerRef}
      >
        <AurSvgIcon src="../assests/images/eca-admin.svg" ariaHidden />
        <Typography className="aur-eca-badge-small-pill-text">
          {smallPillText
            ? smallPillText
            : `${t(stringPath + 'eca')}: ${admin ? t(stringPath + 'admin') : t(stringPath + 'nonAdmin')}`}
        </Typography>
      </div>
      <div className="aur-eca-badge-text-container" ref={textContainerRef}>
        {docSummary ? (
          <AurSvgIcon src="../assests/images/eca-checkmark.svg" />
        ) : (
          <AurSvgIcon src="../assests/images/eca-close.svg" />
        )}
        <Typography
          className={`typo-text body2_size ${docSummary ? 'enabled' : 'disabled'}`}
        >
          {largePillText
            ? largePillText
            : t(stringPath + 'createDocumentSummaries')}
        </Typography>
      </div>
    </div>
  );
};

export default AurEcaBadges;
